// 15°'5 motion system — small progressive enhancements that don't belong in
// the reusable scroll-trigger engine (assets/animations.js). Everything here
// is optional: forms and buttons work identically without it.

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.newsletter-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('.newsletter-form__button');
      if (!button || button.classList.contains('loading')) return;
      button.classList.add('loading');
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    });
  });
});
